(() => {
  if (customElements.get('ro-site-menu')) return;

  class RoSiteMenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.closest('header').querySelectorAll('[data-ro-menu-open]')];
      this.buttons.forEach(button => button.addEventListener('click', () => this.open(button), options));
      this.dialog.querySelector('[data-ro-menu-close]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.restore();
      }, options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.close();
      }, options);
      // A swipe beginning inside the menu must not be mistaken for a backdrop click.
      this.dialog.addEventListener('pointerdown', event => {
        this.outsidePress = this.outside(event);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (this.outsidePress && this.outside(event)) this.close();
        this.outsidePress = false;
        if (event.target.closest('a[href]')) this.close();
      }, options);
      window.addEventListener('resize', () => this.size(), options);
      window.visualViewport?.addEventListener('resize', () => this.size(), options);
      window.addEventListener('pagehide', () => this.close(false), options);
    }

    outside(event) {
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right ||
        event.clientY < box.top || event.clientY > box.bottom;
    }

    size() {
      const height = window.visualViewport?.height || window.innerHeight;
      this.dialog.style.setProperty('--ro-menu-height', `${Math.round(height)}px`);
    }

    open(button) {
      if (this.dialog.open) return;
      this.opener = button;
      this.size();
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.buttons.forEach(item => item.setAttribute('aria-expanded', 'true'));
      // Freeze only the background; never cancel wheel or touch events in the menu.
      const body = document.body;
      this.saved = {
        x: window.scrollX, y: window.scrollY,
        styles: ['position', 'top', 'left', 'width', 'overflow'].map(name =>
          [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)])
      };
      body.style.position = 'fixed';
      body.style.top = `${-this.saved.y}px`;
      body.style.left = `${-this.saved.x}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }

    close(focus = true) {
      if (this.dialog?.open) this.dialog.close();
      this.restore(focus);
    }

    restore(focus = true) {
      if (!this.saved) return;
      const saved = this.saved;
      this.saved = null;
      saved.styles.forEach(([name, value, priority]) => {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      });
      window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
      this.buttons.forEach(item => item.setAttribute('aria-expanded', 'false'));
      if (focus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
    }
  }
  customElements.define('ro-site-menu', RoSiteMenu);
})();
